import React from "react";
import SearchBar from "./components/SearchBar";
import SearchInfo from "./components/SearchInfo";
import { MapContainer, TileLayer, useMap, Marker, Popup } from "react-leaflet";
import RecenterAutomatically from "./components/RecenterAutomatically";

function App() {
	const [searchBoxInfo, setSearchBoxInfo] = React.useState({
		ip: "142.251.40.36",
		location: {
			region: "California",
			country: "US",
			timezone: "-7:00",
			lat: 34.05223,
			lng: -118.24368,
		},
		isp: "Google LLC",
	});

	const searchResult = (val) => {
		let searchURL = `https://geo.ipify.org/api/v2/country,city?apiKey=at_P4yrXMs9o3ely1B9AAvrnArmfzZEE&ipAddress=${val}&domain=${val}`;
		fetch(searchURL).then((res) => {
			if (res.ok) {
				res.json().then((data) => {
					return setSearchBoxInfo((prevSearchBoxInfo) => data);
				});
			} else {
				alert("Incorrect Search Option");
			}
		});
	};

	return (
		<div className="App">
			<header className="header">
				<h1 className="header-heading">IP Address Tracker</h1>
				<SearchBar searchResult={searchResult} />
				<SearchInfo searchBoxInfo={searchBoxInfo} />
			</header>
			<main>
				<MapContainer center={[searchBoxInfo.location.lat, searchBoxInfo.location.lng]} scrollWheelZoom={true} trackResize={true} zoom={13}>
					<TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
					<Marker position={[searchBoxInfo.location.lat, searchBoxInfo.location.lng]}>
						<Popup>
							A pretty CSS3 popup. <br /> Easily customizable.
						</Popup>
					</Marker>
					<RecenterAutomatically lat={searchBoxInfo.location.lat} lng={searchBoxInfo.location.lng} />
				</MapContainer>
			</main>
		</div>
	);
}

export default App;
